import { initialiseNavigation } from './navigation';
import { initialiseDialogs } from './dialogs';

function initialisePageInteractions() {
	initialiseNavigation();
	initialiseDialogs();
	if (document.querySelector('[data-image-carousel]')) {
		void import('./image-carousels')
			.then(module => module.initialiseImageCarousels())
			.catch(error => {
				console.error('Unable to load image carousels', error);
				document.querySelectorAll<HTMLElement>('[data-image-status]').forEach(status => {
					status.classList.remove('visually-hidden');
					status.textContent = 'The slideshow could not load. Please reload the page to try again.';
				});
			});
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initialisePageInteractions, { once: true });
} else {
	initialisePageInteractions();
}
